import { render, staticRenderFns } from "./modalSeleccionarDia.vue?vue&type=template&id=3a5ae47b&scoped=true"
import script from "./modalSeleccionarDia.vue?vue&type=script&lang=js"
export * from "./modalSeleccionarDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ae47b",
  null
  
)

export default component.exports